import { isProdLike } from "./env";

export const BUSINESS_MANAGER_URL = isProdLike()
    ? "https://business.snapchat.com"
    : "https://business-manager.snap-dev.net";

export const ASSET_LIBRARY_GUIDELINES_URL =
    "https://developers.snap.com/lens-studio/learning-lens-studio/asset-library/asset-library-publishing-guide";

export const ASSET_LIBRARY_OVERVIEW_URL =
    "https://developers.snap.com/lens-studio/learning-lens-studio/asset-library/asset-library-overview";

export const PRIVACY_POLICY_URL = "https://www.snap.com/en-US/privacy/privacy-policy/";

export const TERMS_OF_SERVICE_URL = "https://www.snap.com/en-US/terms/";

export const REMOTE_ASSETS_DOCS_URL =
    "https://developers.snap.com/lens-studio/features/lens-cloud/remote-assets-overview";

export const LENS_PLUS_SUBSCRIPTION_URL = "https://www.snapchat.com/plus";

export const LENS_PLUS_TOP_CHARTS_URL = "https://easylens.snapchat.com/topic/lens-plus-top-charts";
